class RecentlyViewedProducts extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    const currentProductId = this.dataset.currentProductId;
    const storageKey = 'smarte_recently_viewed';
    let viewedItems = JSON.parse(localStorage.getItem(storageKey) || '[]');

    // Track current product if on product page
    if (currentProductId) {
      viewedItems = viewedItems.filter((id) => id !== currentProductId);
      viewedItems.unshift(currentProductId);
      if (viewedItems.length > 20) viewedItems.pop();
      localStorage.setItem(storageKey, JSON.stringify(viewedItems));
    }

    // Filter out current page's product from display list
    const itemsToFetch = currentProductId
      ? viewedItems.filter((id) => id !== currentProductId)
      : viewedItems;

    const limit = parseInt(this.dataset.limit || '8', 10);
    const selectedIds = itemsToFetch.slice(0, limit);

    if (selectedIds.length === 0) {
      if (!Shopify.designMode) this.setAttribute('hidden', '');
      return;
    }

    const searchQuery = selectedIds.map((id) => `id:${id}`).join(' OR ');
    const url = `${this.dataset.url}${encodeURIComponent(searchQuery)}`;

    fetch(url)
      .then((res) => res.text())
      .then((htmlText) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlText, 'text/html');
        const container = doc.querySelector('[data-recently-viewed-container]');
        const targetContainer = this.querySelector('[data-recently-viewed-container]');

        if (container && targetContainer && container.children.length > 0) {
          targetContainer.innerHTML = container.innerHTML;
          this.removeAttribute('hidden');

          // Initialize/re-init Swiper instance
          const swiperEl = this.querySelector('[data-smarte-swiper]');
          if (swiperEl) {
            delete swiperEl.dataset.smarteSwiperInitialized;
            if (typeof initSwiper === 'function') {
              initSwiper(swiperEl);
            } else {
              document.dispatchEvent(new CustomEvent('shopify:section:load', { detail: { sectionId: this.id } }));
            }
          }
        } else {
          this.setAttribute('hidden', '');
        }
      })
      .catch(() => {
        this.setAttribute('hidden', '');
      });
  }
}

if (!customElements.get('recently-viewed-products')) {
  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}